(function () {
  var root = document.querySelector('.hb-home');
  if (!root) return;

  /* Marquee pace and seamlessness.
       ticker: 1200px / 40s = 30 px/s
       press:  1030px / 32s = 32.2 px/s

     The track is two identical halves and the animation translates it -50%, so
     the loop only looks continuous while ONE half is at least as wide as the
     visible strip. The design's halves are a fixed 1030px/1200px, which is
     narrower than a desktop window — so the last logo clears the right edge and
     leaves a gap before the set comes back round. Repeat the set inside each
     half until it covers the container, then derive the duration from the new
     width so the designed px/sec is unchanged. */
  function marquee(trackSel, halfSel, boxSel, pace) {
    var track = root.querySelector(trackSel);
    var box = root.querySelector(boxSel);
    if (!track || !box) return;
    var halves = track.querySelectorAll(halfSel);
    if (!halves.length) return;

    var base = [];
    for (var i = 0; i < halves.length; i++) base.push(halves[i].innerHTML);

    var fit = function () {
      var need = box.getBoundingClientRect().width;
      var guard = 0;
      while (halves[0].getBoundingClientRect().width < need && guard < 12) {
        for (var j = 0; j < halves.length; j++) {
          halves[j].insertAdjacentHTML('beforeend', base[j]);
        }
        guard++;
      }
      var w = halves[0].getBoundingClientRect().width;
      if (w > 0) track.style.animationDuration = (w / pace).toFixed(1) + 's';
    };

    fit();
    /* Logos and webfonts settle after first paint and change the measured width. */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    window.addEventListener('load', fit);

    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(fit, 200);
    });
  }

  marquee('.hb-ticker__track', '.hb-ticker__half', '.hb-ticker', 1200 / 40);
  marquee('.hb-press__track', '.hb-press__half', '.hb-press__wrap', 1030 / 32);

  /* FAQ: one panel open at a time */
  root.querySelectorAll('.hb-acc').forEach(function (group) {
    group.querySelectorAll('details').forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        group.querySelectorAll('details').forEach(function (o) {
          if (o !== d) o.open = false;
        });
      });
    });
  });

  /* Mobile sticky buy bar: appears once the hero has scrolled away, so it
     never sits on top of the hero's own button. Also pads the page so the
     bar cannot cover the last line of the footer. */
  (function () {
    var bar = document.querySelector('[data-hb-sticky]');
    var hero = document.querySelector('.hb-hero');
    if (!bar || !hero) return;

    var PAD = '76px';
    function show(on) {
      bar.hidden = false;
      bar.classList.toggle('hb-sticky--on', on);
      document.body.style.paddingBottom = on && window.innerWidth <= 749 ? PAD : '';
    }

    if (!('IntersectionObserver' in window)) { show(true); return; }
    new IntersectionObserver(function (entries) {
      show(!entries[0].isIntersecting);
    }, { threshold: 0 }).observe(hero);

    /* Rotating to landscape can cross the breakpoint either way. */
    window.addEventListener('resize', function () {
      if (bar.classList.contains('hb-sticky--on')) show(true);
      else document.body.style.paddingBottom = '';
    });
  })();

  /* Proof screenshots: click or tap to zoom, drag to pan */
  /* Below 750px the proof screenshots are plain images -- see hb-home.css.
     Binding the pointer handlers anyway would swallow scroll gestures that
     start on the image. */
  var ZOOMABLE = window.matchMedia('(min-width: 750px)').matches;

  root.querySelectorAll('[data-zoom]').forEach(function (box) {
    if (!ZOOMABLE) return;
    if (box.__zoomed) return;
    box.__zoomed = true;
    var img = box.querySelector('img');
    if (!img) return;

    var scale = 1, tx = 0, ty = 0;
    var pts = new Map();
    var startDist = 0, startScale = 1, startMid = null, startT = null, lastTap = 0;
    /* The proof screenshots are stored around 1120px wide and display at up to
       900px, so there is only so much real detail to magnify. Past ~3x it is
       upscaling rather than revealing anything. */
    var MAXZOOM = 3, TAPZOOM = 2.2;
    var downAt = null, dragged = false;

    var clamp = function () {
      scale = Math.min(MAXZOOM, Math.max(1, scale));
      var w = box.clientWidth, h = img.offsetHeight;
      tx = Math.min(0, Math.max(w - w * scale, tx));
      ty = Math.min(0, Math.max(h - h * scale, ty));
      if (scale === 1) { tx = 0; ty = 0; }
    };
    var apply = function () {
      clamp();
      img.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
      box.style.cursor = scale > 1 ? 'grab' : 'zoom-in';
    };
    var arr = function () { return Array.from(pts.values()); };
    var mid = function () {
      var a = arr();
      return { x: (a[0].x + a[1].x) / 2, y: (a[0].y + a[1].y) / 2 };
    };
    var dist = function () {
      var a = arr();
      return Math.hypot(a[0].x - a[1].x, a[0].y - a[1].y);
    };
    var local = function (p) {
      var r = box.getBoundingClientRect();
      return { x: p.x - r.left, y: p.y - r.top };
    };

    /* Zoom toward a point, or back out if already zoomed. */
    var toggleAt = function (px, py) {
      var next = scale > 1 ? 1 : TAPZOOM;
      tx = px - (px - tx) * (next / scale);
      ty = py - (py - ty) * (next / scale);
      scale = next;
      if (next === 1) { tx = 0; ty = 0; }
      apply();
    };

    box.addEventListener('pointerdown', function (e) {
      box.setPointerCapture(e.pointerId);
      pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (pts.size === 1) { downAt = { x: e.clientX, y: e.clientY }; dragged = false; }
      if (pts.size === 2) {
        startDist = dist(); startScale = scale; startMid = local(mid()); startT = { tx: tx, ty: ty };
      } else if (pts.size === 1) {
        startMid = local({ x: e.clientX, y: e.clientY });
        startT = { tx: tx, ty: ty };
        lastTap = Date.now();
      }
    });

    box.addEventListener('pointermove', function (e) {
      if (!pts.has(e.pointerId)) return;
      if (downAt && Math.hypot(e.clientX - downAt.x, e.clientY - downAt.y) > 6) dragged = true;
      pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (pts.size === 2) {
        var k = dist() / (startDist || 1);
        var next = Math.min(MAXZOOM, Math.max(1, startScale * k));
        tx = startMid.x - (startMid.x - startT.tx) * (next / startScale);
        ty = startMid.y - (startMid.y - startT.ty) * (next / startScale);
        scale = next;
        apply();
      } else if (pts.size === 1 && scale > 1) {
        var p = local({ x: e.clientX, y: e.clientY });
        tx = startT.tx + (p.x - startMid.x);
        ty = startT.ty + (p.y - startMid.y);
        apply();
      }
    });

    var release = function (e) {
      var wasSingle = pts.size === 1;
      pts.delete(e.pointerId);
      if (pts.size === 1) { startMid = local(arr()[0]); startT = { tx: tx, ty: ty }; }
      /* A click or tap that did not turn into a pan zooms in on that spot.
         Without this the image only responded to pinch or ctrl+scroll, which
         reads as broken on a desktop mouse. */
      if (wasSingle && !dragged && e.type === 'pointerup' && downAt) {
        var r = box.getBoundingClientRect();
        toggleAt(e.clientX - r.left, e.clientY - r.top);
      }
      downAt = null;
    };
    box.addEventListener('pointerup', release);
    box.addEventListener('pointercancel', release);

    box.addEventListener('wheel', function (e) {
      if (!e.ctrlKey && !e.metaKey) return;
      e.preventDefault();
      var r = box.getBoundingClientRect();
      var px = e.clientX - r.left, py = e.clientY - r.top;
      var next = Math.min(MAXZOOM, Math.max(1, scale * (e.deltaY < 0 ? 1.12 : 0.89)));
      tx = px - (px - tx) * (next / scale);
      ty = py - (py - ty) * (next / scale);
      scale = next;
      apply();
    }, { passive: false });

    /* No dblclick handler: the single-click toggle above already covers it,
       and a second handler would zoom in then straight back out. */
  });
})();
